var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.outDetails.out_ip_data)?_c('app-punch-geolocation-data',{attrs:{"details":_vm.outDetails,"key-data":"out_ip_data"}}):_c('div',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }